import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/hf/HFLink';
import { trackEvent, trackLegacyEvent } from 'helpers/analytics';
import css from 'styles/components/hf/zappos/footerBottom.scss';
import marketplace from 'cfg/marketplace.json';

const { phoneNumber, phoneNumberVip } = marketplace;

const FooterBottom = ({ holmes }, { testId = () => null }) => {
  const isVip = holmes && holmes.vip;
  const number = isVip ? phoneNumberVip : phoneNumber;

  return (
    <div className={css.container}>
      <div className={css.links}>
        <Link
          to="/c/terms-of-use"
          data-test-id={testId('footerTermsOfUse')}
          onClick={() => {
            trackEvent('TE_FOOTER_POLICIES', 'Terms of Use');
            trackLegacyEvent('Footer', 'Legal-Policies', 'Terms-of-Use');
          }}>
          Terms of Use
        </Link>
        <Link
          to="/c/privacy-policy"
          data-test-id={testId('footerPrivacyPolicy')}
          onClick={() => {
            trackEvent('TE_FOOTER_POLICIES', 'Privacy Policy');
            trackLegacyEvent('Footer', 'Legal-Policies', 'Privacy-Policy');
          }}>
          Privacy Policy
        </Link>
        <Link
          to="/c/fur-policy"
          data-test-id={testId('footerFurPolicy')}
          onClick={() => {
            trackEvent('TE_FOOTER_POLICIES', 'Fur-Policy');
            trackLegacyEvent('Footer', 'Legal-Policies', 'Fur-Policy');
          }}>
          Fur Policy
        </Link>
        <Link
          to="/c/interest-based-ads-policy"
          data-test-id={testId('footerInternetBasedAds')}
          onClick={() => {
            trackEvent('TE_FOOTER_POLICIES', 'Interest Based Ads Policy');
            trackLegacyEvent('Footer', 'Legal-Policies', 'Interest-Based-Ads-Policy');
          }}>
          Interest-Based Ads
        </Link>
        <Link
          to="/contact-us"
          data-test-id={testId('footerCustomerService')}
          onClick={() => {
            trackEvent('TE_FOOTER_POLICIES', '24-7 Customer Service');
            trackLegacyEvent('Footer', 'Legal-Policies', '24-7-Customer-Service');
          }}>
          24/7 Customer Service {number}
        </Link>
      </div>
      <div>
        <p className={css.botCopy} data-test-id={testId('footerLegalCopy')}>
          &copy; 2009&ndash;{new Date().getFullYear()} - Zappos LLC or its affiliates, 400 E. Stewart Avenue, Las Vegas, <abbr title="Nevada">NV</abbr> 89101<br/>
          Zappos.com is operated by Zappos IP LLC. Products on Zappos.com are sold by Zappos Retail LLC.<br/>
          Gift cards and e-Gift cards sold on Zappos.com are sold by Zappos Gift Cards LLC or ACI Gift Cards LLC.
        </p>
      </div>
    </div>
  );
};

FooterBottom.contextTypes = {
  testId: PropTypes.func
};

export default FooterBottom;
